
/* DarkGear Theme JS v3.1 */
(function(){
'use strict';

/* ── THEME TOGGLE ────────────────────────────────────────── */
/* v9.1.12 fix #35: stopPropagation evita que el click bubble a listeners de
   ancestros (FOUC del am-overlay o handlers de header global). Aislado. */
function initTheme(){
  if(localStorage.getItem('dg-theme')==='light') setLight();
  ['theme-toggle','drawer-theme-toggle'].forEach(function(id){
    var el=document.getElementById(id);
    if(el) el.addEventListener('click',function(e){
      e.stopPropagation();
      if(document.documentElement.classList.contains('day')){setDark();localStorage.setItem('dg-theme','dark');}
      else{setLight();localStorage.setItem('dg-theme','light');}
    });
  });
}
function setLight(){document.documentElement.classList.add('day');document.querySelectorAll('.tgl').forEach(function(t){t.classList.add('on');});}
function setDark(){document.documentElement.classList.remove('day');document.querySelectorAll('.tgl').forEach(function(t){t.classList.remove('on');});}

/* ── DRAWERS ─────────────────────────────────────────────── */
function initDrawers(){
  var hbg=document.getElementById('hbg');
  var overlay=document.getElementById('drawer-overlay');
  var closeBtn=document.getElementById('mobile-drawer-close');
  if(!hbg) return;
  hbg.addEventListener('click',function(){
    if(window.innerWidth<=768){openMobileDrawer();}
    else{var dd=document.getElementById('nav-dropdown');if(dd){var isOpen=dd.classList.contains('open');dd.classList.toggle('open',!isOpen);hbg.classList.toggle('open',!isOpen);if(overlay)overlay.classList.toggle('on',!isOpen);}}
  });
  if(closeBtn) closeBtn.addEventListener('click',closeMobileDrawer);
  if(overlay) overlay.addEventListener('click',function(){closeMobileDrawer();var dd=document.getElementById('nav-dropdown');if(dd)dd.classList.remove('open');if(hbg)hbg.classList.remove('open');overlay.classList.remove('on');});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMobileDrawer();closeCartDrawer();closeSearch();}});
}
function openMobileDrawer(){var d=document.getElementById('mobile-drawer');var o=document.getElementById('drawer-overlay');var hbg=document.getElementById('hbg');if(d)d.classList.add('open');if(o)o.classList.add('on');if(hbg)hbg.classList.add('open');document.body.style.overflow='hidden';}
function closeMobileDrawer(){var d=document.getElementById('mobile-drawer');var o=document.getElementById('drawer-overlay');var hbg=document.getElementById('hbg');if(d)d.classList.remove('open');if(o)o.classList.remove('on');if(hbg)hbg.classList.remove('open');document.body.style.overflow='';}

/* ── CART DRAWER ─────────────────────────────────────────── */
function initCartDrawer(){
  var cartBtn=document.getElementById('cart-btn');
  var closeBtn=document.getElementById('cart-drawer-close');
  var overlay=document.querySelector('.cart-drawer-overlay');
  if(cartBtn) cartBtn.addEventListener('click',function(e){e.preventDefault();openCartDrawer();});
  if(closeBtn) closeBtn.addEventListener('click',closeCartDrawer);
  if(overlay) overlay.addEventListener('click',closeCartDrawer);
  /* v9.1.13 fix #20: GA4 begin_checkout cuando se clica "Finalizar compra".
     No prevent: Shopify procesa el submit normalmente. */
  var checkoutBtn=document.getElementById('cart-drawer-checkout-btn');
  if(checkoutBtn) checkoutBtn.addEventListener('click',function(){
    try{
      if(window.gtag){
        fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
          var cur=window.shopCurrency||'USD';
          var items=(c.items||[]).map(function(i){return{item_id:i.sku||String(i.variant_id||i.id),item_name:i.product_title||i.title,price:(i.price||0)/100,quantity:i.quantity||1};});
          window.gtag('event','begin_checkout',{currency:cur,value:(c.total_price||0)/100,items:items});
        }).catch(function(){});
      }
      if(window.fbq){window.fbq('track','InitiateCheckout');}
    }catch(e){/* silent */}
  });
}
function openCartDrawer(){
  var d=document.getElementById('cart-drawer');if(!d)return;
  d.classList.add('open');document.body.style.overflow='hidden';refreshCartDrawer();
  /* v9.1.13 fix #20: GA4 view_cart al abrir el drawer */
  try{
    if(window.gtag){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
        var cur=window.shopCurrency||'USD';
        var items=(c.items||[]).map(function(i){return{item_id:i.sku||String(i.variant_id||i.id),item_name:i.product_title||i.title,price:(i.price||0)/100,quantity:i.quantity||1};});
        window.gtag('event','view_cart',{currency:cur,value:(c.total_price||0)/100,items:items});
      }).catch(function(){});
    }
  }catch(e){/* silent */}
}
function closeCartDrawer(){var d=document.getElementById('cart-drawer');if(d){d.classList.remove('open');document.body.style.overflow='';}}
function refreshCartDrawer(){
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    updateCartCount(cart.item_count);updateShippingBar(cart.total_price);renderCartItems(cart);updateCartTotal(cart.total_price);
  }).catch(function(){});
}
function renderCartItems(cart){
  var container=document.getElementById('cart-drawer-items');
  var drawer=document.getElementById('cart-drawer');
  var countEl=document.getElementById('cart-count-drawer');
  if(!container) return;
  if(countEl) countEl.textContent=cart.item_count;
  /* v9.1.13 fix F6.9b: toggle .is-empty del drawer para mostrar/ocultar footer
     Subtotal+Checkout sin destruir el DOM. */
  if(drawer){
    if(cart.item_count===0) drawer.classList.add('is-empty');
    else drawer.classList.remove('is-empty');
  }
  if(cart.item_count===0){container.innerHTML='<div class="cart-drawer-empty"><p>Tu carrito está vacío</p><a href="'+(window.routes&&window.routes.all_products_url||'/collections/all')+'" class="btn btn-outline btn-sm">Ver productos</a></div>';return;}
  var html=cart.items.map(function(item){
    return '<div class="cart-drawer-item" data-key="'+item.key+'">'+
      '<div class="cart-drawer-item-img">'+(item.image?'<img src="'+item.image+'" alt="'+item.title.replace(/"/g,'&quot;')+'" loading="lazy">':'<div style="font-size:24px">📦</div>')+'</div>'+
      '<div><div class="cart-drawer-item-title">'+item.product_title+'</div>'+
      (item.variant_title&&item.variant_title!=='Default Title'?'<div class="cart-drawer-item-variant">'+item.variant_title+'</div>':'')+
      '<div class="cart-drawer-item-bottom"><div class="cart-drawer-qty"><button class="cart-drawer-qty-btn" data-key="'+item.key+'" data-delta="-1">−</button><span class="cart-drawer-qty-val">'+item.quantity+'</span><button class="cart-drawer-qty-btn" data-key="'+item.key+'" data-delta="1">+</button></div>'+
      '<div class="cart-drawer-item-price">'+formatMoney(item.final_line_price)+'</div></div></div></div>';
  }).join('');
  container.innerHTML=html;
  container.querySelectorAll('.cart-drawer-qty-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var key=btn.getAttribute('data-key');var delta=parseInt(btn.getAttribute('data-delta'));
      var valEl=btn.parentNode.querySelector('.cart-drawer-qty-val');
      var qty=Math.max(0,parseInt(valEl?valEl.textContent:1)+delta);
      cartUpdate(key,qty);
    });
  });
}
function cartUpdate(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(){refreshCartDrawer();});}
function updateCartTotal(p){
  var el=document.getElementById('cart-drawer-total');if(el)el.textContent=formatMoney(p);
  /* v9.1.13 fix F6.9b: refrescar texto del botón "Finalizar compra" con total */
  var btn=document.getElementById('cart-drawer-checkout-btn');
  if(btn) btn.textContent='Finalizar compra — '+formatMoney(p);
}
function formatMoney(cents){
  /* v9.1.10 fix #7: usar shopCurrency del backend (fallback USD), no EUR */
  var cur=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||window.shopCurrency||'USD';
  var loc=(document.documentElement.lang||'es-ES').replace('_','-');
  try{return(cents/100).toLocaleString(loc,{style:'currency',currency:cur});}
  catch(e){return(cents/100).toLocaleString('en-US',{style:'currency',currency:'USD'});}
}

/* ── SHIPPING BAR ────────────────────────────────────────── */
/* v9.1.10 fix #11: leer freeShippingThreshold del backend (cents), no hardcoded */
var FREE_SHIP=(window.themeSettings&&window.themeSettings.freeShippingThreshold)||5000;
function updateShippingBar(total){
  var bar=document.querySelector('.shipping-bar');if(!bar)return;
  var remaining=FREE_SHIP-total;var pct=Math.min((total/FREE_SHIP)*100,100);
  var textEl=bar.querySelector('.shipping-bar-text');var fillEl=bar.querySelector('.shipping-bar-fill');
  if(fillEl)fillEl.style.width=pct+'%';
  if(textEl){if(remaining<=0){textEl.innerHTML='🎉 <strong>¡Envío gratis desbloqueado!</strong>';}else{textEl.innerHTML='Añade <strong>'+formatMoney(remaining)+'</strong> más para envío gratis';}}
}

/* ── CART COUNT ──────────────────────────────────────────── */
function updateCartCount(n){document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=n;el.setAttribute('data-count',n);});}
function fetchCartCount(){fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){updateCartCount(cart.item_count);updateShippingBar(cart.total_price);}).catch(function(){});}

/* ── ADD TO CART ─────────────────────────────────────────── */
function initATC(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-atc]');if(!btn)return;
    var id=btn.getAttribute('data-atc');if(id)addToCart(id,1,btn);
  });
}
function addToCart(variantId,qty,btn){
  if(btn)btn.classList.add('loading');
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(variantId),quantity:qty||1})})
  .then(function(r){return r.json();})
  .then(function(item){
    if(item.status){showToast(item.description||'Error');return;}
    /* v9.1.10 fix #20: GA4 add_to_cart event */
    try{
      if(window.gtag){
        var cur=(window.shopCurrency||'USD');
        var val=(item.final_line_price||item.price||0)/100;
        window.gtag('event','add_to_cart',{currency:cur,value:val,items:[{item_id:item.sku||String(item.variant_id||item.id),item_name:item.product_title||item.title,price:(item.price||0)/100,quantity:qty||1}]});
      }
      if(window.fbq){window.fbq('track','AddToCart',{content_ids:[String(item.variant_id||item.id)],content_type:'product',value:(item.final_line_price||item.price||0)/100,currency:(window.shopCurrency||'USD')});}
    }catch(e){/* silent */}
    fetchCartCount();showToast((item.title||'Producto')+' añadido al carrito');
    if(btn){btn.classList.remove('loading');var orig=btn.textContent;btn.textContent='✓ Añadido';btn.classList.add('added');setTimeout(function(){btn.classList.remove('added');btn.textContent=orig;},2200);}
    setTimeout(function(){openCartDrawer();},300);
  })
  .catch(function(){if(btn)btn.classList.remove('loading');showToast('No se pudo añadir. Inténtalo de nuevo.');});
}

/* ── PREDICTIVE SEARCH ───────────────────────────────────── */
/* v9.1.13 fix #8: dropdown inline bajo el header input (sin focus-switch al overlay).
   Mantengo el overlay como fallback opcional (no se abre automáticamente). */
/* Fix móvil: se agrega hookInput() para el buscador del drawer móvil
   (#drawer-search-input / #drawer-search-results), que existía en el
   HTML pero nunca estaba conectado con la búsqueda predictiva. */
function initSearch(){
  var headerInput=document.getElementById('header-search-input');
  var headerResults=document.getElementById('header-search-results');
  var overlay=document.getElementById('search-overlay');
  var closeBtn=document.getElementById('search-close');
  var overlayInput=document.getElementById('search-input');
  var overlayResults=document.getElementById('search-results');
  var drawerInput=document.getElementById('drawer-search-input');
  var drawerResults=document.getElementById('drawer-search-results');
  if(closeBtn)closeBtn.addEventListener('click',closeSearch);
  if(overlay)overlay.addEventListener('click',function(e){if(e.target===overlay)closeSearch();});
  function hookInput(input,resultsEl){
    if(!input)return;var timer;
    input.addEventListener('input',function(){
      clearTimeout(timer);var q=input.value.trim();
      if(q.length<2){if(resultsEl){resultsEl.classList.remove('open');resultsEl.innerHTML='';}return;}
      timer=setTimeout(function(){predictiveSearch(q,resultsEl);},280);
    });
    input.addEventListener('blur',function(){
      /* Delay close para permitir click en un resultado antes de que se oculte */
      setTimeout(function(){if(resultsEl)resultsEl.classList.remove('open');},180);
    });
  }
  hookInput(headerInput,headerResults);
  hookInput(overlayInput,overlayResults);
  hookInput(drawerInput,drawerResults);
}
function closeSearch(){var o=document.getElementById('search-overlay');var r=document.getElementById('search-results');if(o)o.classList.remove('open');if(r)r.classList.remove('open');}
function predictiveSearch(query,containerOverride){
  fetch('/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=6&resources[fields]=title,image,price,url')
  .then(function(r){return r.json();}).then(function(data){
    var products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
    renderSearchResults(products,query,containerOverride);
  }).catch(function(){});
}
function renderSearchResults(products,query,containerOverride){
  var container=containerOverride||document.getElementById('search-results');if(!container)return;
  if(!products.length){container.innerHTML='<div class="search-no-results">Sin resultados para "'+query+'"</div>';}
  else{container.innerHTML=products.map(function(p){var price=p.price?formatMoney(p.price):'';var img=p.featured_image?(p.featured_image.url||p.featured_image):'';
    return'<a href="'+p.url+'" class="search-result-item">'+(img?'<img class="search-result-img" src="'+img+'" alt="'+p.title.replace(/"/g,'&quot;')+'" loading="lazy">':'<div class="search-result-img" style="font-size:24px;display:flex;align-items:center;justify-content:center">📦</div>')+
    '<div><div class="search-result-title">'+p.title+'</div>'+(price?'<div class="search-result-price">'+price+'</div>':'')+
    '</div></a>';}).join('');}
  container.classList.add('open');
}

/* ── PRODUCT PAGE ────────────────────────────────────────── */
function initProductPage(){
  document.querySelectorAll('.product-thumb').forEach(function(t){t.addEventListener('click',function(){document.querySelectorAll('.product-thumb').forEach(function(x){x.classList.remove('active');});t.classList.add('active');var mainImg=document.getElementById('main-product-img');if(mainImg&&t.dataset.src)mainImg.src=t.dataset.src;});});
  var variantsJson=document.getElementById('product-variants-json');
  if(variantsJson){var variants=JSON.parse(variantsJson.textContent);
    document.querySelectorAll('.variant-btn').forEach(function(btn){btn.addEventListener('click',function(){if(btn.classList.contains('sold-out'))return;var group=btn.closest('.variant-btns');if(group)group.querySelectorAll('.variant-btn').forEach(function(b){b.classList.remove('active');});btn.classList.add('active');updateVariant(variants);});});
    document.querySelectorAll('.color-swatch').forEach(function(sw){sw.addEventListener('click',function(){if(sw.classList.contains('sold-out'))return;var group=sw.closest('.swatch-group');if(group)group.querySelectorAll('.color-swatch').forEach(function(s){s.classList.remove('active');});sw.classList.add('active');updateVariant(variants);});});
    updateAvailability(variants);
  }
  ['product-atc-btn','product-mobile-atc-btn'].forEach(function(id){var btn=document.getElementById(id);if(btn)btn.addEventListener('click',function(){var vid=btn.getAttribute('data-variant-id');var qty=parseInt((document.getElementById('product-qty')||{}).value||1);if(vid&&!btn.disabled)addToCart(vid,qty,btn);});});
  var minus=document.getElementById('qty-minus');var plus=document.getElementById('qty-plus');var qtyInput=document.getElementById('product-qty');
  if(minus&&qtyInput)minus.addEventListener('click',function(){var v=parseInt(qtyInput.value)||1;if(v>1)qtyInput.value=v-1;});
  /* v9.1.10 fix #24: respetar max del input (default 99) */
  if(plus&&qtyInput)plus.addEventListener('click',function(){var v=parseInt(qtyInput.value)||1;var max=parseInt(qtyInput.getAttribute('max'))||99;if(v<max)qtyInput.value=v+1;});
  document.querySelectorAll('.tab-btn').forEach(function(btn){btn.addEventListener('click',function(){var target=btn.getAttribute('data-tab');var section=btn.closest('.product-tabs');if(!section)return;section.querySelectorAll('.tab-btn').forEach(function(b){b.classList.remove('active');});section.querySelectorAll('.tab-panel').forEach(function(p){p.classList.remove('active');});btn.classList.add('active');var panel=section.querySelector('#tab-'+target);if(panel)panel.classList.add('active');});});
  document.querySelectorAll('.share-btn').forEach(function(btn){btn.addEventListener('click',function(){var type=btn.getAttribute('data-share');var url=window.location.href;var title=document.title;if(type==='copy'){navigator.clipboard.writeText(url).then(function(){var orig=btn.textContent;btn.textContent='✓ Copiado!';setTimeout(function(){btn.textContent=orig;},1800);});}else if(type==='twitter'){window.open('https://twitter.com/intent/tweet?url='+encodeURIComponent(url)+'&text='+encodeURIComponent(title),'_blank');}else if(type==='whatsapp'){window.open('https://wa.me/?text='+encodeURIComponent(title+' '+url),'_blank');}else if(type==='facebook'){window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url),'_blank');}});});
  /* v9.1.10 fix #5: ELIMINADO fake urgency Math.random (dark pattern, riesgo legal UE/UK) */
}
function updateVariant(variants){
  var btnValues=[];
  document.querySelectorAll('.variant-btn.active,.color-swatch.active').forEach(function(b){btnValues.push(b.getAttribute('data-value'));});
  if(!btnValues.length)return;
  var variant=variants.find(function(v){return btnValues.every(function(val){return v.option1===val||v.option2===val||v.option3===val;});});
  /* v9.1.10 fix #19: NO caer al primer variant. Si no hay match, mostrar 'No disponible' sin actualizar precio */
  var priceEl=document.querySelector('.product-price');var compareEl=document.querySelector('.product-compare-price');
  if(!variant){
    ['product-atc-btn','product-mobile-atc-btn'].forEach(function(id){var b=document.getElementById(id);if(b){b.disabled=true;b.textContent='No disponible';}});
    return;
  }
  if(priceEl)priceEl.textContent=formatMoney(variant.price);
  if(compareEl){if(variant.compare_at_price&&variant.compare_at_price>variant.price){compareEl.textContent=formatMoney(variant.compare_at_price);compareEl.style.display='';}else{compareEl.style.display='none';}}
  ['product-atc-btn','product-mobile-atc-btn'].forEach(function(id){var b=document.getElementById(id);if(b){b.setAttribute('data-variant-id',variant.id);b.disabled=!variant.available;b.textContent=variant.available?'Añadir al carrito':'Agotado';}});
  if(variant.featured_image&&variant.featured_image.src){var mainImg=document.getElementById('main-product-img');if(mainImg)mainImg.src=variant.featured_image.src;}
  updateAvailability(variants);
}
/* v9.1.5 — variant picker disable sold-out combinations (I-4 fix Code firma 33 round 3) */
function updateAvailability(variants){
  if(!variants||!variants.length)return;
  document.querySelectorAll('.variant-btns, .swatch-group').forEach(function(group){
    var firstBtn=group.querySelector('[data-option]');if(!firstBtn)return;
    var thisOptionName=firstBtn.getAttribute('data-option');
    var otherSelected={};
    document.querySelectorAll('.variant-btn.active, .color-swatch.active').forEach(function(activeBtn){
      var optName=activeBtn.getAttribute('data-option');
      if(optName!==thisOptionName)otherSelected[optName]=activeBtn.getAttribute('data-value');
    });
    group.querySelectorAll('button[data-option][data-value]').forEach(function(btn){
      var thisValue=btn.getAttribute('data-value');
      var combined=Object.assign({},otherSelected);combined[thisOptionName]=thisValue;
      var found=variants.find(function(v){
        return Object.keys(combined).every(function(optName){
          var val=combined[optName];return v.option1===val||v.option2===val||v.option3===val;
        });
      });
      if(found&&found.available){btn.classList.remove('sold-out');btn.disabled=false;}
      else{btn.classList.add('sold-out');btn.disabled=true;}
    });
  });
}

/* ── CART PAGE ───────────────────────────────────────────── */
function initCartPage(){
  document.querySelectorAll('.cart-item-remove').forEach(function(btn){
    btn.addEventListener('click',function(){
      var line=btn.getAttribute('data-line');
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(line),quantity:0})}).then(function(){window.location.reload();});
    });
  });
}

/* ── COUNTDOWN ───────────────────────────────────────────── */
function initCountdown(){
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var endDate=new Date(el.getAttribute('data-countdown'));if(isNaN(endDate.getTime()))return;
    function tick(){var now=new Date();var diff=endDate-now;if(diff<=0)return;
      var d=Math.floor(diff/86400000);var h=Math.floor((diff%86400000)/3600000);var m=Math.floor((diff%3600000)/60000);var s=Math.floor((diff%60000)/1000);
      var days=el.querySelector('.cd-days');var hours=el.querySelector('.cd-hours');var mins=el.querySelector('.cd-mins');var secs=el.querySelector('.cd-secs');
      if(days)days.textContent=String(d).padStart(2,'0');if(hours)hours.textContent=String(h).padStart(2,'0');if(mins)mins.textContent=String(m).padStart(2,'0');if(secs)secs.textContent=String(s).padStart(2,'0');
    }
    tick();setInterval(tick,1000);
  });
}

/* ── WISHLIST ────────────────────────────────────────────── */
function initWishlist(){
  var wl=getWishlist();
  document.querySelectorAll('.pc-wishlist').forEach(function(btn){if(wl.includes(btn.getAttribute('data-id')))btn.classList.add('active');});
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.pc-wishlist');if(!btn)return;e.preventDefault();e.stopPropagation();
    var id=btn.getAttribute('data-id');if(!id)return;var wl=getWishlist();
    if(wl.includes(id)){wl=wl.filter(function(x){return x!==id;});btn.classList.remove('active');showToast('Eliminado de favoritos');}
    else{wl.push(id);btn.classList.add('active');showToast('Añadido a favoritos ♥');}
    setWishlist(wl);
  });
}
function getWishlist(){try{return JSON.parse(localStorage.getItem('dg-wishlist')||'[]');}catch(e){return[];}}
function setWishlist(arr){localStorage.setItem('dg-wishlist',JSON.stringify(arr));}

/* ── NEWSLETTER POPUP ────────────────────────────────────── */
function initNewsletterPopup(){
  if(localStorage.getItem('dg-nl-dismissed'))return;
  var popup=document.getElementById('nl-popup-overlay');if(!popup)return;
  var delay=(window.themeSettings&&window.themeSettings.newsletterPopupDelay)||6000;
  setTimeout(function(){popup.classList.add('open');},delay);
  function dismiss(){popup.classList.remove('open');localStorage.setItem('dg-nl-dismissed','1');}
  var closeBtn=document.getElementById('nl-popup-close');var skipBtn=document.getElementById('nl-popup-skip');var form=document.getElementById('nl-popup-form');
  if(closeBtn)closeBtn.addEventListener('click',dismiss);if(skipBtn)skipBtn.addEventListener('click',dismiss);
  popup.addEventListener('click',function(e){if(e.target===popup)dismiss();});
  if(form){form.addEventListener('submit',function(e){e.preventDefault();var success=document.getElementById('nl-popup-success');if(success)success.style.display='block';form.style.display='none';setTimeout(dismiss,2500);});}
}

/* ── COOKIE BAR ──────────────────────────────────────────── */
function initCookieBar(){
  if(localStorage.getItem('dg-cookies-accepted'))return;
  var bar=document.getElementById('cookie-bar');if(!bar)return;
  bar.classList.add('show');
  var a=document.getElementById('cookie-accept');var d=document.getElementById('cookie-decline');
  if(a)a.addEventListener('click',function(){bar.classList.remove('show');localStorage.setItem('dg-cookies-accepted','1');});
  if(d)d.addEventListener('click',function(){bar.classList.remove('show');localStorage.setItem('dg-cookies-accepted','0');});
}

/* ── COLLECTION FILTERS ──────────────────────────────────── */
function initCollectionFilters(){
  var sort=document.getElementById('collection-sort');if(sort)sort.addEventListener('change',function(){window.location.href=sort.value;});
  var priceBtn=document.getElementById('price-filter-apply');
  if(priceBtn)priceBtn.addEventListener('click',function(){var min=document.getElementById('price-min');var max=document.getElementById('price-max');if(!min||!max)return;var params=new URLSearchParams(window.location.search);params.set('filter.v.price.gte',min.value||'0');params.set('filter.v.price.lte',max.value||'99999');window.location.search=params.toString();});
}

/* ── TOAST ───────────────────────────────────────────────── */
function showToast(msg){var toast=document.getElementById('toast');var txt=document.getElementById('toast-msg');if(!toast)return;if(txt)txt.textContent=msg;toast.classList.add('show');clearTimeout(toast._timer);toast._timer=setTimeout(function(){toast.classList.remove('show');},3000);}

/* ── INIT ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',function(){
  initTheme();initDrawers();initCartDrawer();initATC();initSearch();
  initProductPage();initCartPage();initCountdown();initWishlist();
  initNewsletterPopup();initCookieBar();initCollectionFilters();fetchCartCount();
});
})();

/* ── Ocultar nombre del proveedor en toda la web ────────────────── */
/* v9.1.10 fix #9: regex acotado a CJ específico (era /proveedor[:：]?\s*\S+/gi que rompía cualquier mención
   normal de 'proveedor' en blogs/políticas). Mantiene CJ Dropshipping oculto pero no toca palabras inocentes.
   También skipea inputs, textareas, script/style/code para no romper formularios. */
(function(){
  var SUPPLIER_PATTERNS = [
    /CJ\s*dropshipping/gi,
    /CJdropshipping/gi,
    /cjdropshipping\.com/gi,
  ];
  var SKIP_TAGS = {INPUT:1,TEXTAREA:1,SELECT:1,SCRIPT:1,STYLE:1,CODE:1,PRE:1};

  function cleanNode(node){
    if(node.nodeType === 3){
      var orig = node.textContent;
      var clean = orig;
      SUPPLIER_PATTERNS.forEach(function(p){ clean = clean.replace(p,''); });
      if(clean !== orig) node.textContent = clean;
    } else if(node.nodeType === 1){
      if(SKIP_TAGS[node.tagName]) return;
      var t = node.textContent.trim();
      var isSup = SUPPLIER_PATTERNS.some(function(p){ p.lastIndex=0; return p.test(t); });
      if(isSup && t.length < 60){ node.style.display='none'; return; }
      Array.from(node.childNodes).forEach(cleanNode);
    }
  }

  function cleanDOM(){
    cleanNode(document.body);
  }

  // Limpiar al cargar
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', cleanDOM);
  } else {
    cleanDOM();
  }

  // Limpiar cambios dinámicos (carruseles, AJAX, etc.)
  var observer = new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(n){ cleanNode(n); });
    });
  });
  observer.observe(document.body, {childList:true, subtree:true});
})();
